<template>
    <div id="app">
        <div class="main">
            <div class="header">
                <div class="logo_img" @click="logoClick">
                    <div style="display: flex; align-items: center; float: left; height: 65px">
                        <div class="header-logo">
                            <img id="header-img" src="../assets/logo.jpg" />
                        </div>
                    </div>
                    <div style="display: flex; float: left; height: 65px">
                        <div class="header-important">
                            <div class="company_name">安永（中国）保健品有限公司</div>
                            <div class="header-title company_name">anyongjiankang.cn</div>
                        </div>
                    </div>
                </div>
                <div id="menu_index">
                    <!-- web端菜单导航 -->
                    <el-menu
                        v-if="seen"
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        menu-trigger="click"
                        text-color="#333"
                        style="height: 65px; border: 0"
                        mode="horizontal"
                        @select="handleSelect"
                    >
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-submenu index="2">
                            <template slot="title">产品与解决方案</template>
                            <el-menu-item index="2-1">产品微观</el-menu-item>
                            <el-menu-item index="2-2">生鲜果蔬</el-menu-item>
                            <el-menu-item index="2-3" disabled>服装品牌</el-menu-item>
                            <el-menu-item index="2-4" disabled>微商城小程序</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                        <el-menu-item index="4" class="header-title">关于App</el-menu-item>
                        <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                        <el-menu-item index="6" class="header-title">隐私协议</el-menu-item>
                    </el-menu>
                    <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                    <el-menu
                        v-if="!seen"
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        menu-trigger="click"
                        text-color="#333"
                        style="height: 65px; border: 0"
                        mode="horizontal"
                        @select="handleSelectMobile"
                    >
                        <el-submenu index="1" class="header-title mobile_menu">
                            <template slot="title">{{ currentMenu }}</template>
                            <el-menu-item index="1" class="header-title">首页</el-menu-item>
                            <el-menu-item index="2-2" class="header-title">生鲜果蔬</el-menu-item>
                            <el-menu-item index="2-1" class="header-title">产品微观</el-menu-item>
                            <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                            <el-menu-item index="4" class="header-title">关于App</el-menu-item>
                            <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                            <el-menu-item index="6" class="header-title">隐私协议</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </div>
            <div class="container">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </div>

            <div style="float: left; width: 100%; margin-top: 20px">
                <div
                    style="
                        width: 90%;
                        margin: auto;
                        height: 1px;
                        padding: 0;
                        background-color: #999;
                    "
                ></div>
            </div>
            <div class="footer" style="margin: 10px; padding: 20px 0">
                <div style="float: left; width: 100%">
                    <div style="margin: auto" class="footer_font">
                        <a href="https://beian.miit.gov.cn">互联网ICP备案：粤ICP备17079200号-2</a>
                    </div>
                    <div style="margin: auto" class="footer_font">
                        ©anyongjiankang.cn 安永（中国）保健品有限公司版权所有
                    </div>
                </div>
            </div>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px; width: 35px" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Layout',
    data() {
        return {
            activeIndex: '1',
            company: {
                qrcode: require('../../static/other/公众号二维码.jpg')
            },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页'
        };
    },
    methods: {
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'Index' });
                    break;
                case '2-1':
                    window.location.hash = '#产品微观';
                    break;
                case '2-2':
                    this.$router.push({ name: 'Fruit' });
                    break;
                case '2-3':
                    this.$router.push({ name: 'Fashion' });
                    break;
                case '3':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#产品特点';
                    break;
                case '4':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#关于App';
                    break;
                case '5':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#关于我们';
                    break;
                case '6':
                    this.$router.push({ name: 'secret' });
                    window.location.hash = '#隐私协议';
                    break;
            }
        },
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'Index' });
                    this.currentMenu = '首页';
                    break;
                case '2-1':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#产品微观';
                    this.currentMenu = '首页';
                    break;
                case '2-2':
                    this.$router.push({ name: 'Fruit' });
                    this.currentMenu = '生鲜果蔬';
                    break;
                case '2-3':
                    this.$router.push({ name: 'Fashion' });
                    break;
                case '3':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#产品特点';
                    this.currentMenu = '首页';
                    break;
                case '4':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#关于App';
                    this.currentMenu = '首页';
                    break;
                case '5':
                    this.$router.push({ name: 'Index' });
                    window.location.hash = '#关于我们';
                    this.currentMenu = '首页';
                    break;
            }
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 600) {
                //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block';
            } else {
                this.$refs.btn.style.display = 'none';
            }
        },
        backTop() {
            //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer);
                }
            }, 30);
        },
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                this.seen = true;
            } else {
                this.seen = false;
            }
        },
        logoClick() {
            this.$router.push({ name: 'Index' });
            this.currentMenu = '首页';
        }
    },
    mounted() {
        this.menuSeen();
        window.addEventListener('scroll', this.handleScroll);
    }
};
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
* {
    margin: 0;
    padding: 0;
}
.el-submenu__title {
    font-size: 16px;
}

.logo_img {
    float: left;
    width: 30%;
    cursor: pointer;
}
#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer;
}
.header-title {
    font-size: 1em;
}
.company_name {
    font-weight: normal;
    font-size: 1em;
}
.footer_font {
    font-size: 1em;
}
#menu_index {
    float: left;
    width: 50%;
    height: 100%;
}
.header {
    margin: auto;
    width: 90%;
    height: 65px;
    /*background: #F56C6C;*/
}
@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }
    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer;
    }
    .footer_font {
        font-size: 0.875em;
    }
    #menu_index {
        float: right;
        width: auto;
        height: 100%;
    }
    .mobile_menu {
    }
}
.main {
    margin: auto;
    float: left;
    width: 100%;
    border: 0;
}
#header-img {
    width: 50px;
    height: 50px;
    float: left;
    margin: auto;
}
.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}
.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 90%;
}
a {
    text-decoration: none;
}
a:visited {
    text-decoration: none;
}
a:hover {
    text-decoration: none;
}
a:active {
    text-decoration: none;
}

.border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
}

.slider_img {
    height: 550px;
    width: 100%;
}

.solve {
    display: flex;
    margin-top: 30px;
    margin-bottom: 10px;
}

.border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 20%;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
}

.product_mobile_content {
    width: 50%;
}

.product_mobile_img {
    float: left;
    height: 510px;
    width: 250px;
    margin-left: 50px;
}

.product_mobile_title {
    font-weight: bold;
}

.product_pc_one {
    width: 50%;
    float: left;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    height: 510px;
    width: 600px;
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    height: 540px;
    margin: 20px auto;
    background: #f2f6fc;
    align-items: center;
}

.product_spec_title {
    display: flex;
    margin-top: 30px;
    margin-bottom: 10px;
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto;
}

.cooperation_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto;
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    width: 60%;
    text-align: left;
    margin: 10px;
}

.border_title {
    font-family: 'PingFang SC';
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px;
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    /*background-color: aqua;*/
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
}

.border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
}

.cooperation {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    display: flex;
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: 540px;
    background: #f2f6fc;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
}

.product_mobile_content_two {
    margin-top: 10px;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }

    .solve {
        display: flex;
        margin-top: 5px;
        margin-bottom: 10px;
    }

    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #ebeef5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;
    }

    .product_mobile {
        display: flex;
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #f2f6fc;
        flex-direction: column;
        justify-content: center;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
        height: 280px;
        width: 160px;
        /*margin-left: 5px;*/
        margin: auto;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #f2f6fc;
        flex-direction: column;
    }

    .product_spec_title {
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1em;
        font-weight: normal;
        width: 90%;
        text-align: left;
        margin: 5px;
    }

    .border_title {
        font-family: 'PingFang SC';
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px;
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        justify-content: center;
        width: 100%;
    }
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center;
}

.font_size_24 {
    font-size: 1.5em;
}

.el-menu-item {
    font-size: 14px;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.el-menu-item * {
    vertical-align: middle;
}
.el-menu-item i {
    color: #909399;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: #ecf5ff;
}
.el-menu-item.is-disabled {
    opacity: 0.25;
    cursor: not-allowed;
    background: 0 0 !important;
}
.el-menu-item [class^='el-icon-'] {
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
}
</style>
